/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespHeroCarouselRequestMoreImages_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_user">;
    readonly " $refType": "PdpRespHeroCarouselRequestMoreImages_user";
};
export type PdpRespHeroCarouselRequestMoreImages_user$data = PdpRespHeroCarouselRequestMoreImages_user;
export type PdpRespHeroCarouselRequestMoreImages_user$key = {
    readonly " $data"?: PdpRespHeroCarouselRequestMoreImages_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarouselRequestMoreImages_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '1312d899977bc0e275bac12dd2af63cc';
export default node;
